import {NavigationHelpers} from '@react-navigation/native';
import {LocalParamList} from '../../shared/components/tabBar/components/types';
import View, {IStateProps} from './view';
import {Screens} from '../../shared/routing';
import {VisuallyImpairedForm} from '../../shared/components/visuallyImpaired/form';

export interface Props {
  navigation: NavigationHelpers<LocalParamList>;
}

export const VisuallyImpairedSettingsScreen = ({navigation}: Props) => {
  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      (navigation.navigate as any)(Screens.MainTabs, {screen: Screens.CardServicesMenu});
    }
  };
  const props: IStateProps = {
    onGoBackClick: goBack,
  };

  return VisuallyImpairedForm<IStateProps>({
    render: View,
    props,
  });
};
